import React from 'react';
import { Footer } from '../components/Footer';
import Header from '../components/Header';

const Terms: React.FC = () => {

  return (
    <div className="min-h-screen bg-white">
      {/* Shared Header Component */}
      <Header />
      
      {/* Content with padding for fixed header */}
      <div className="pt-16">
        <div className="container mx-auto px-4 py-12 max-w-4xl">
          <h1 className="text-3xl font-bold mb-8 text-center text-gray-800">Terms of Service</h1>
          
          <div className="prose prose-lg mx-auto">
            <p className="mb-4">
              Last Updated: Dec 1, 2024
            </p>

            <h2 className="text-xl font-semibold mt-8 mb-4">1. Acceptance of Terms</h2>
            <p className="mb-4">
              By accessing or using the AgilisCare platform, you agree to be bound by these Terms of Service. If you do not agree to these terms, please do not use our services.
            </p>

            <h2 className="text-xl font-semibold mt-8 mb-4">2. Description of Service</h2>
            <p className="mb-4">
              AgilisCare provides administrative tools and informational support to assist healthcare professionals in their clinical workflows, documentation, and information retrieval tasks. Our service is intended to be used by qualified medical professionals only and is designed to augment, not replace, professional medical judgment.
            </p>
            <p className="mb-4 font-medium">
              The platform is a clinical decision support tool that assists healthcare professionals with administrative and informational tasks, but all medical decisions remain the sole responsibility of the healthcare professional.
            </p>

            <h2 className="text-xl font-semibold mt-8 mb-4">3. User Accounts</h2>
            <p className="mb-4">
              When registering for AgilisCare, you agree to provide accurate and complete information. You are responsible for maintaining the security of your account and password. You are fully responsible for all activities that occur under your account.
            </p>

            <h2 className="text-xl font-semibold mt-8 mb-4">4. Acceptable Use</h2>
            <p className="mb-4">
              You agree to use our services only for lawful purposes and in accordance with these Terms. You agree not to:
            </p>
            <ul className="list-disc pl-8 mb-4">
              <li>Use the service for any illegal purpose</li>
              <li>Attempt to gain unauthorized access to any portion of the service</li>
              <li>Interfere with or disrupt the integrity or performance of the service</li>
              <li>Collect or harvest any information from the service</li>
              <li>Impersonate any person or entity</li>
              <li>Upload or transmit any viruses, malware, or other malicious code</li>
              <li>Rely solely on the information provided by the service for making medical diagnoses or treatment decisions</li>
            </ul>

            <h2 className="text-xl font-semibold mt-8 mb-4 bg-indigo-50 p-3">5. Clinical Decision Support Disclaimer</h2>
            <div className="bg-indigo-50 p-4 mb-4">
              <p className="mb-4">
                AgilisCare is a clinical workflow and documentation assistance tool. It is not intended to be used for automated diagnosis or treatment decisions.
              </p>
              <p className="mb-4">
                <strong>The service does not make medical decisions.</strong> Any information provided by our AI is for informational purposes only and is intended to augment, not replace, professional medical judgment. Healthcare professionals must exercise their own professional judgment in diagnosing and treating patients.
              </p>
              <p className="mb-4">
                The platform focuses primarily on enhancing administrative efficiency, improving documentation, and providing informational resources to support healthcare professionals in their practice.
              </p>
            </div>

            <h2 className="text-xl font-semibold mt-8 mb-4">6. Patient Data and Privacy</h2>
            <p className="mb-4">
              Healthcare professionals using AgilisCare are responsible for obtaining appropriate patient consent and for complying with all applicable laws and regulations regarding patient privacy and data protection, including but not limited to HIPAA, GDPR, and other local healthcare privacy laws.
            </p>

            <h2 className="text-xl font-semibold mt-8 mb-4">7. Intellectual Property</h2>
            <p className="mb-4">
              All content, features, and functionality of AgilisCare, including but not limited to text, graphics, logos, icons, and software, are the exclusive property of Agilis AI and are protected by copyright, trademark, and other intellectual property laws.
            </p>

            <h2 className="text-xl font-semibold mt-8 mb-4">8. Limitation of Liability</h2>
            <p className="mb-4">
              To the maximum extent permitted by law, Agilis AI shall not be liable for any indirect, incidental, special, consequential, or punitive damages, including without limitation, loss of profits, data, or use, arising out of or in connection with the use of our service, whether based on contract, tort, negligence, strict liability, or otherwise.
            </p>
            <p className="mb-4">
              Agilis AI specifically disclaims all liability for any medical decisions made by healthcare professionals, regardless of whether such professionals used our service in the course of their decision-making process.
            </p>

            <h2 className="text-xl font-semibold mt-8 mb-4">9. Changes to Terms</h2>
            <p className="mb-4">
              We may update these Terms of Service from time to time. We will notify users of any material changes by posting the new Terms on this page and updating the "Last Updated" date at the top of this document. You are advised to review these Terms periodically for any changes.
            </p>

            <h2 className="text-xl font-semibold mt-8 mb-4">10. Governing Law</h2>
            <p className="mb-4">
              These Terms shall be governed by and construed in accordance with the laws of the People's Republic of China, without regard to its conflict of law provisions.
            </p>

            <h2 className="text-xl font-semibold mt-8 mb-4">11. Contact Us</h2>
            <p className="mb-4">
              If you have any questions about these Terms, please contact us at legal@agiliscare.com.
            </p>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default Terms; 